module.exports = __webpack_public_path__ + "static/media/promo-left.c223748a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/promo-left.jpg
// module id = 1186
// module chunks = 0